const $ = require('jquery');

class ExpandCollapse {
  init() {
    $('.mammout__expand_collapse__text').click(e => {
      e.stopPropagation();
      e.preventDefault();
      $(e.currentTarget)
        .next()
        .toggleClass('expanded');
    });
  }
}

export default (() => new ExpandCollapse())();
